import { api } from "@/lib/api";

export const pushSupported = () =>
  typeof window !== "undefined" && "serviceWorker" in navigator && "PushManager" in window && "Notification" in window;

export const isStandalone = () =>
  window.matchMedia?.("(display-mode: standalone)").matches || window.navigator.standalone === true;

function toKey(value) {
  const pad = "=".repeat((4 - (value.length % 4)) % 4);
  const raw = window.atob((value + pad).replace(/-/g, "+").replace(/_/g, "/"));
  return Uint8Array.from([...raw].map((c) => c.charCodeAt(0)));
}

const ready = () => Promise.race([
  navigator.serviceWorker.ready,
  new Promise((_, rej) => setTimeout(() => rej(new Error("Service worker not ready")), 4000)),
]);

export async function pushStatus() {
  if (!pushSupported()) return "unsupported";
  if (Notification.permission === "denied") return "denied";
  try {
    const reg = await ready();
    const sub = await reg.pushManager.getSubscription();
    return sub ? "on" : "off";
  } catch {
    return "off";
  }
}

export async function enablePush() {
  if (!pushSupported()) throw new Error("This browser can't receive push alerts. On iPhone/iPad, add the app to your Home Screen from Safari first (iOS 16.4 or newer).");
  const perm = await Notification.requestPermission();   // first, while the tap's user-activation is still fresh (iOS requirement)
  if (perm !== "granted") throw new Error("Notifications were not allowed. On iPhone: Settings → Notifications → XAU Terminal → Allow.");
  const reg = await ready();
  const { data } = await api.get("/push/public-key");
  let sub = await reg.pushManager.getSubscription();
  if (!sub) sub = await reg.pushManager.subscribe({ userVisibleOnly: true, applicationServerKey: toKey(data.public_key) });
  await api.post("/push/subscribe", sub.toJSON());
  return sub;
}

export async function disablePush() {
  const reg = await ready();
  const sub = await reg.pushManager.getSubscription();
  if (!sub) return;
  await api.delete("/push/unsubscribe", { data: { endpoint: sub.endpoint } }).catch(() => {});
  await sub.unsubscribe();
}
